import { css, Theme } from '@emotion/react'
import styled from '@emotion/styled'

import { getLinkStyle } from '../styles'

const spacedElements = 'p, ol, ul, h1, h2, h3, h4, h5, h6'

export const th = (theme: Theme) => css`
  color: ${theme.colors.secondaryLabel};
  background: ${theme.colors.secondaryBackground};
  font-weight: ${theme.weights.medium};
`

const StructuredContent = styled.div`
  ${props => props.theme.typography.bodyText};
  color: ${props => props.theme.colors.secondaryLabel};
  margin-top: 1rem;
  margin-bottom: 1rem;

  a[href] {
    ${props => getLinkStyle(props.theme)};
  }

  img {
    max-width: 100%;
  }

  ol,
  ul {
    padding-left: 1.5rem;
    list-style-position: outside;
  }

  ol {
    list-style-type: decimal;
  }

  ul {
    list-style-type: disc;
  }

  *:is(${spacedElements}) {
    margin: 1rem 0;
  }

  table *:is(${spacedElements}):first-of-type {
    margin-top: 0;
  }

  table *:is(${spacedElements}):last-child {
    margin-bottom: 0;
  }

  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: 0.5rem;
    border: 1px solid ${props => props.theme.colors.hairline};
  }

  th {
    ${props => th(props.theme)};
  }
`

export default StructuredContent
